import { i18n, notify } from "@dehub/theme";

export const translateIfKey = (msg: string): string => {
  if (typeof msg !== "string" || !msg.startsWith("error.")) return msg;
  const translated = i18n.t(msg, { ns: "errors", defaultValue: "" });
  if (typeof translated === "string" && translated.length > 0) return translated;
  return i18n.t("error.title", { ns: "errors", defaultValue: i18n.t("common:errorOccurred") });
};

const success = (message: string) => {
  notify.success({ title: i18n.t("common:requestSuccess"), message });
};

const error = (message: string) => {
  notify.error({ title: i18n.t("common:requestFailed"), message: translateIfKey(message) });
};

export const message = {
  success,
  error,
};
